export default __webpack_public_path__ + "static/media/character_description.45c8238a.png";